import React from "react";
import { GetServerSideProps } from 'next';
import APIServices from '@/apiUtils/APIServices';
import FAQComponent from '@/components/landing/home/faq';
import SEO from '@/components/landing/seo';
import LandingLayout from '@/components/landing/home/LandingLayout';

const FAQ = (props) => {
  const structredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: props?.data?.data?.map((data) => {
      return {
        '@type': data?.question,
        name: data?.answer,
        acceptedAnswer: {
          '@type': 'Answer',
          text: data?.answer,
        },
      };
    }),
  };

  return (
    <>
      <SEO
        meta_title={'Frequently asked questions | Learnsic'}
        meta_description={''}
        meta_keywords={'faq, learnsic, confusion'}
        photo={''}
        schemas={structredData}
        canonical="faq"
      />
      <LandingLayout>
        <FAQComponent props={props} />
      </LandingLayout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { data, success } = await new APIServices(
    `/faq/`
  ).get();
  return {
    props: {
      data: data,
    },
  };
};

export default FAQ;
